import { render, staticRenderFns } from "./NotificationComponent.vue?vue&type=template&id=623ef853&"
import script from "./NotificationComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623ef853')) {
      api.createRecord('623ef853', component.options)
    } else {
      api.reload('623ef853', component.options)
    }
    module.hot.accept("./NotificationComponent.vue?vue&type=template&id=623ef853&", function () {
      api.rerender('623ef853', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/notification/NotificationComponent.vue"
export default component.exports